import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { CurrencyData } from '../../_models/currency';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';
import { UserData } from '../../_models/users';
import { phoneNumberValidator } from '../../_services/validators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrl: './manage.component.css'
})
export class UserManageComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  kycUrl = environment.kycUrl;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "All Entities";
  formHeader: string = "Add New Entity";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Entity";

  userist: UserData[] = [];
  currencyList: CurrencyData[] = [];
  selectedUser: UserData = null;
  selectedUserLoading: boolean = false;
  selectedUserTab: string = 'overview';

  edit: boolean = false;
  docTypeName: string = '';
  docTypeRef: number = 0;

  publicKey: string = localStorage.getItem('publicKey');

  dataForm = this.fb.group({
    ref: [0],
    name: ["", Validators.required],
    lastName: ["", Validators.required],
    firstName: ["", Validators.required],
    phone: ["", [Validators.required, phoneNumberValidator()]],
    email: ["", Validators.required],
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get name() { return this.dataForm.get('name'); }
  get lastName() { return this.dataForm.get('lastName'); }
  get firstName() { return this.dataForm.get('firstName'); }
  get phone() { return this.dataForm.get('phone'); }
  get email() { return this.dataForm.get('email'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List " + this.capitalizeFirstLetter(this.view ) + " Entities";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getUser(this.page);
  }

  getUser(page:number) {
    this.loading = true;

    this.apiService.getUser(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.userist = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      name: this.dataForm.value.name,
      fname: this.dataForm.value.firstName,
      lname: this.dataForm.value.lastName,
      email: this.dataForm.value.email,
      phone: this.dataForm.value.phone,
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editUser(data);
    } else {
      data['online'] = 0;
      this.createUser(data);
    }
  }

  createUser( data ) {
    this.processing = true;

    this.buttonText = "Adding New Entity...";
    this.apiService.createUser(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.title+" as an Entity", "Entity Created");
          this.ngOnInit();
          this.dataForm.reset();
          document.getElementById('modal-activate').click();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Entity";
      }
    );
  }

  editUser( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
    this.apiService.editUser(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to Entity", "Entity Edited");
          this.ngOnInit();
          this.dataForm.reset();
          document.getElementById('modal-activate').click();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Entity";
        this.edit = false;
      }
    );
  }

  getEdit(data:UserData) {
    this.dataForm.patchValue({
      ref: data.ref,
      name: data.companyDetails.name,
      lastName: data.lastName,
      firstName: data.firstName,
      phone: data.phone,
      email: data.email,
    });
    this.edit = true;
    this.formHeader = "Edit "+data.companyDetails.name;
    this.buttonText = "Edit Entity";
  }

  sendEmail(data:UserData, emailType: string) {
    this.apiService.sendEmail(data.ref, emailType).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        if (user.success == true) {
          this.notifyService.showSuccess("KYC Notification email has been sent to " + data.firstName, "KYC E-Mail");
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
      }
    );
  }

  openUserDrawer(userRow: UserData) {
    if (!userRow || !userRow.ref) {
      return;
    }

    this.selectedUser = userRow;
    this.selectedUserTab = 'overview';
    this.selectedUserLoading = true;
    this.apiService.getOneUser(userRow.ref).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.selectedUserLoading = false;
        if (data.success == true) {
          this.selectedUser = data.data;
        } else {
          this.notifyService.showError(data.error.message, 'Error');
        }
      }
    );
  }

  closeUserDrawer() {
    this.selectedUser = null;
    this.selectedUserLoading = false;
    this.selectedUserTab = 'overview';
  }

  setUserDrawerTab(tab: string) {
    this.selectedUserTab = tab;
  }

  userStatusLabel(user: UserData = this.selectedUser): string {
    if (!user || !user.status) {
      return '-';
    }

    return user.status.active === true ? 'active' : user.status.new === true ? 'kyc needed' : user.status.kycApproved === true ? 'kyc approved' : user.status.inactive === true ? 'inactive' : 'kyc submitted';
  }

  documentStatusLabel(status: any): string {
    if (!status) {
      return '-';
    }

    return status.approved === true ? 'approved' : status.rejected === true ? 'rejected' : status.new === true ? 'new' : 'pending';
  }

  displayValue(value: any): string {
    return value === null || value === undefined || value === '' ? '-' : String(value);
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset();
    document.getElementById('modal-activate').click();
    this.formHeader = this.buttonText = "Add New Entity";
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  changeUserStatus(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeUserStatus(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Entity successfully", "Entity Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  deleteUser(ref:number) {
    this.processing = true;

    this.apiService.deleteUser(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Entity Removed Successfully", "Entity Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.docTypeName = name;
    this.docTypeRef = ref;
  }
  
  formatPhoneNumber(form: FormGroup, controlName: string): void {
    const input = form.get(controlName).value as string;
    const cleaned = input.replace(/\D+/g, ''); // Remove non-digit characters
    const match = cleaned.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      form.get(controlName).setValue(
        `+${match[1]} (${match[2]}) ${match[3]} ${match[4]}`
      );
    }
  }

  printName(details:UserData) {
    return (details.companyDetails.ref == 0)? details.firstName + " " + details.lastName : details.companyDetails.name
  }

  capitalizeFirstLetter(text: string): string {
    if (text == "kycApproved" || text == "kycapproved") {
      text = "Approved KYC";
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
